var _path, _rect, _path2, _circle, _circle2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgElementSegment(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 52 7",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17 0a1 1 0 011 1v5a1 1 0 01-1 1l-9.258.001A5.478 5.478 0 009 3.501 5.482 5.482 0 007.742-.002L17 0zM7 3.5c0 .954-.381 1.819-1 2.45v-4.9c.619.631 1 1.496 1 2.45z",
    fill: "#667B84"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    fill: "#009DE0",
    x: 20,
    width: 12,
    height: 7,
    rx: 1
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M43 3.5c0 1.33.472 2.55 1.258 3.501H35a1 1 0 01-1-1V1a1 1 0 011-1l9.258-.002A5.478 5.478 0 0043 3.5zm3-2.449V5.95a3.489 3.489 0 01-1-2.45c0-.953.381-1.818 1-2.449z",
    fill: "#667B84"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    fill: "#667B84",
    cx: 48.5,
    cy: 3.5,
    r: 3.5
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    fill: "#667B84",
    cx: 3.5,
    cy: 3.5,
    r: 3.5
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgElementSegment);
export default __webpack_public_path__ + "static/media/ElementSegment.0e8a74916d67995442497f3b082192ad.svg";
export { ForwardRef as ReactComponent };